import { formatInTimeZone } from "date-fns-tz";
import { roadsenseWorkbookFilename } from "../plugins/roadsense/workbook-filename";

/** The daily run, and so every report email's period, follows Sydney's calendar. */
const ROADSENSE_TIMEZONE = "Australia/Sydney";

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * An example of what a site's emailed workbook is saved as, for
 * `WhatYoullReceivePanel`. The page doesn't know the site's hire start, so the
 * example runs from the first of the month to yesterday (Sydney), the day a
 * report email sent today covers up to. Only the dates are illustrative: the
 * name follows `roadsenseWorkbookFilename`, as the real attachment does.
 */
export function roadsenseExampleWorkbookFilename(siteName: string, now: Date): string {
  const today = formatInTimeZone(now, ROADSENSE_TIMEZONE, "yyyy-MM-dd");
  const periodEnd = new Date(Date.parse(`${today}T00:00:00Z`) - DAY_MS).toISOString().slice(0, 10);
  const periodStart = `${periodEnd.slice(0, 8)}01`;
  return roadsenseWorkbookFilename({ siteName, periodStart, periodEnd });
}
